// chatFlowController.ts

class ChatFlowController {
  private threadResolver?: (value: any) => void;
  private userMessageResolver?: (value: any) => void;

  private threadPromise!: Promise<any>;
  private userMessagePromise!: Promise<any>;

  constructor() {
    this.reset();
  }

  initFlow() {
    this.reset();
  }

  private reset() {
    this.threadPromise = new Promise<any>((resolve) => {
      this.threadResolver = resolve;
    });

    this.userMessagePromise = new Promise<any>((resolve) => {
      this.userMessageResolver = resolve;
    });
  }

  // Step 1: Tạo thread
  resolveThread(thread: any) {
    this.threadResolver?.(thread);
  }
  waitForThread(): Promise<any> {
    return this.threadPromise;
  }

  // Step 2: Gửi user message
  resolveUserMessage(message: any) {
    this.userMessageResolver?.(message);
  }
  waitForUserMessage(): Promise<any> {
    return this.userMessagePromise;
  }
}

export const chatFlowController = new ChatFlowController();
 